export default __webpack_public_path__ + "static/media/Cairo-ExtraLight.36571f0f.ttf";